import React, { Component } from 'react'
import { Modal, Button, Card, Spinner } from 'react-bootstrap';
import axios from 'axios';

import './StyleModal.css';
function viewLicenseV3(req) {
  return new Promise((resolve, reject) => {
    let licenseID = req.licenseID || 'none'
    // console.log(licenseID)
    if (licenseID == '9999999999999') {
      return resolve({
        "data": "Success!",
        "licenseDetail": [{
          'WeightLeft': '0',
          'Destination': '',
          'ProductDescription': 'testtest',
          'QuantityUnit': '',
          'Quantity': 1,
          'ExchangeRate': 1,
          'PricePerUnit': '1',
        }]
      })
    }
    else {
      fetch(`https://backend2.riceinspections.com/search?code=${licenseID}`)
        .then(response => {
          return response.json()
        })
        .then(data => {
          let tempData = [];
          if (data === 'Not Found') {
            reject({ error: 'Not found!' })
          } else {
            let dt = data.PaperlessDetail.LicenseDetail;
            if (!Array.isArray(dt)) {
              dt = [dt]
            }
            dt.forEach((out) => {
              let isHaveTON = false
              isHaveTON = Number.isFinite(out.NetWeightTON)
              if(isHaveTON){
                tempData.push({
                  "WeightLeft": parseFloat(out.NetWeightTON).toFixed(6),
                  "ProductDescription": out.ProductDescription,
                  "QuantityUnit": out.QuantityUnit,
                  "Quantity": out.Quantity,
                  "Destination": data.BuyerCountry,
                  "ExchangeRate": data.ExchangeRate,
                  "PricePerUnit": out.PricePerUnit,
                  "TariffType": out.TariffType
                })  
              }else{
                let KGMtoTON = 0
                KGMtoTON = (parseFloat(out.NetWeightKGM.replace(',',''))/1e3).toFixed(6)
                tempData.push({
                  "WeightLeft": KGMtoTON,
                  "ProductDescription": out.ProductDescription,
                  "QuantityUnit": out.QuantityUnit,
                  "Quantity": out.Quantity,
                  "Destination": data.BuyerCountry,
                  "ExchangeRate": data.ExchangeRate,
                  "PricePerUnit": out.PricePerUnit,
                  "TariffType": out.TariffType
                })  

              }

            })
            let newDataExporter = ''
            console.log(data)
            let isFonudCompanay = data['Exporter']?.indexOf('บริษัท') 
            if(isFonudCompanay != -1){
              newDataExporter = data['Exporter']
            }else{
              newDataExporter = data['Recipient']
            }
            return resolve({
              "data": "Success!",
              "licenseDetail": tempData,
              "companyDescription": newDataExporter
            })
          }
        }).catch((err) => {
          console.log('catch')
          return reject(err)
        })
    }
  })

}
class RequestModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      licenseDetail: [],
      msg: '',
    }
  }

  componentWillMount() {
    // console.log(this.props)
    viewLicenseV3({ 'licenseID': this.props.licenseID })
      .then(res => {
        console.log(res)
        this.setState({
          licenseDetail: res.licenseDetail,
          companyDescription: res.companyDescription,
          msg: res.data,
        }, () => { this.handleSelectAll(this.state.licenseDetail, () => { this.props.onHide() }) })
      })
      .catch(err => {
        console.log(err)
        this.setState({
          ...this.state,
          msg: err['error'],
        })
      })
  }
  handleSelect = (e) => {
    this.props.submit(this.state.licenseDetail[e.target.id], () => {
      this.props.onHide()
    }, e.target.id)
  }
  handleSelectAll = () => {
    // console.log(this.state.licenseDetail)
    this.props.submitAll(this.state.licenseDetail, this.state.companyDescription,
      () => { this.props.onHide() });
  }
  renderList() {
    if (this.state.msg === 'Success!') {
      let list = []
      this.state.licenseDetail.map((a, idx) => (
        list.push(<Card>
          <Card.Body>
            <Card.Text>
              <p>
                {a.ProductDescription}
              </p>
              <footer className="blockquote-footer">
                ปริมาณส่งออกคงเหลือ {a.WeightLeft} ตัน
              </footer>
            </Card.Text>
            <Button id={idx} variant="success" onClick={this.handleSelect} style={{ float: 'right' }}>เลือก</Button>
          </Card.Body>
        </Card>)
      ))
      return list
    } else if (this.state.msg === 'Not found!') {
      return <p>ไม่พบใบอนุญาต </p>
    } else {
      return (
        <div className="center">
          <Spinner animation="border"></Spinner>
          <p className="text">กำลังค้นหาใบอนุญาต</p>
        </div>
      )
    }
  }
  render() {
    let { msg } = this.state;
    return (
      <Modal
        {...this.props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            เพิ่มใบอนุญาต
          </Modal.Title>

        </Modal.Header>
        <Modal.Body>
          <div className={msg === 'Success!' ? 'button-display' : 'button-hide'} align="right">
            <Button onClick={this.handleSelectAll} variant="success">เลือกทั้งหมด</Button>
          </div>
          {this.renderList()}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={this.props.onHide}>ปิด</Button>
        </Modal.Footer>
      </Modal >
    )
  }

}

export default RequestModal
